const Categories = ({ categories, active, onSelect }) => {
  return (
    <div className="categories">
      <div className="categories-list">

        <div
          className={`category ${active === "All" ? "active" : ""}`}
          onClick={() => onSelect("All")}
        >
          <p>All</p>
        </div>

        {categories.map((cat) => (
          <div
            key={cat.id}
            className={`category ${active === cat.name ? "active" : ""}`}
            onClick={() => onSelect(cat.name)}
          >
            <p>{cat.name}</p>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Categories;
